import { VuexModule, Mutation, Module } from 'vuex-module-decorators'
import Store from '@/store/index'

@Module({ dynamic: true, store: Store, name: 'title', namespaced: true })
export default class TitleModule extends VuexModule {
  private title: string = ''

  @Mutation
  public setPageTitle(title: string): void {
    this.title = title
    document.title = title
    localStorage.setItem('title', JSON.stringify(title))
  }

  get pageTitle(): string {
    return this.title
  }
}
